import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormSelect,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { updateLoan } from "src/redux/actions/customerAction";
import authInstance from "src/api/apiConfig";
import { formatDate } from "src/services/helpers";
import {
  COMPANY_AddLogo,
  COMPANY_Address,
  COMPANY_NAME,
} from "src/services/const";

const LoanStatus = () => {
  const dispatch = useDispatch();
  const [allCustomerData, setAllCustomerData] = useState([]);
  const [newData, setNewData] = useState(allCustomerData);
  const [showEmiDetails, setShowEmiDetails] = useState(true);
  const componentPDF = useRef();
  const [printState, setPrintState] = useState(false);
  const SchemaName = sessionStorage.getItem("schemaName");
  const [currSelect, setCurrSelect] = useState("");
  const [checkedState, setCheckedState] = useState({});
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dealers, setDealers] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState("");

  useEffect(() => {
    getAllDealers();
    getAllLoansData();
  }, []);

  useEffect(() => {
    if (printState) {
      generatePDF();
    }
  }, [printState]);

  useEffect(() => {
    setNewData(allCustomerData);
  }, [allCustomerData]);

  const getAllLoansData = async () => {
    const payload = { schemaName: SchemaName };
    try {
      const res = await authInstance.post("getDisLoans", payload);
      setAllCustomerData(res?.data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getAllDealers = async () => {
    const payload = { schemaName: SchemaName };
    try {
      const res = await authInstance.post("getAllBranches", payload);
      setDealers(res?.data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  const download_btn = () => {
    setPrintState(true);
  };

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "userData",
    onAfterPrint: () => setPrintState(false),
  });


  const handleSearch = async () => {
    const payload = {
      schemaName: SchemaName,
      branchId: selectedBranchId || undefined,
      status: currSelect || undefined,
      startDate: startDate || undefined,
      endDate: endDate || undefined,
    };

    try {
      const res = await authInstance.post("getDisLoans", payload);
      const newCustomerData = res?.data?.data || [];
      setAllCustomerData(newCustomerData);
      const newChecked = {};
      newCustomerData.forEach((item, idx) => {
        newChecked[idx] = item?.loans?.[0]?.approvalfilecharge ?? false;
      });
      setCheckedState(newChecked);
    } catch (error) {
      console.error("Search failed", error);
    }
  };

  const handleCheckboxChange = (index, loanid) => {
    const newCheckedState = !checkedState[index];
    setCheckedState((prevState) => ({
      ...prevState,
      [index]: newCheckedState,
    }));
    const newData = {
      schemaName: SchemaName,
      approvalfilecharge: newCheckedState,
    };

    const obj = {
      id: loanid,
      data: newData,
    };
    dispatch(updateLoan(obj));
  };


  const getTotalApprovalAmount = () => {
    return newData.reduce((acc, company) => {
      const amt = Number(company?.loans?.[0]?.approvalAmount) || 0;
      return acc + amt;
    }, 0);
  };

  return (
    <div className="content">
      <CCard className="custom-card">
        <CCardHeader
          className=" custom-card-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <h5 style={{ marginTop: "6px" }}>Loan Details</h5>

            <div className="d-flex">
              <CButton
                className="custom-submit-btn mr-10 w-auto"
                onClick={download_btn}
              >
                Download
              </CButton>

              {showEmiDetails === false ? (
                <CButton
                  className="custom-submit-btn m-0 w-auto"
                  onClick={() => setShowEmiDetails(true)}
                >
                  Back
                </CButton>
              ) : (
                ""
              )}
            </div>
          </div>
        </CCardHeader>
        <CCardBody>
          <div>
            <CRow
              style={{
                width: "-webkit-fill-available !important",
                alignItems: "end",
                justifyContent: "end",
              }}
            >
              <CCol xs={6}>
                <span className="lable-name">Start Date:</span>
                <input
                  type="date"
                  className="custom-form-input"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </CCol>

              <CCol xs={6}>
                <span className="lable-name">End Date:</span>
                <input
                  type="date"
                  className="custom-form-input"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </CCol>

              <CCol xs={12}>
                <span className="lable-name">Select Branch:</span>
                <CFormSelect
                  value={selectedBranchId}
                  className="custom-form-input"
                  onChange={(e) => setSelectedBranchId(e.target.value)}
                >
                  <option value="">All Dealers</option>
                  {dealers.map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.branchName}
                    </option>
                  ))}
                </CFormSelect>
              </CCol>

              <CCol xs={6}>
                <div>
                  <span className="lable-name">Select Status :</span>
                  <CFormSelect
                    value={currSelect}
                    className="custom-form-input"
                    onChange={(e) => setCurrSelect(e.target.value)}
                  >
                    <option value={""}>Select Status</option>
                    <option value={"pending"}>Pending</option>
                    <option value={"reject"}>Reject</option>
                    <option value={"approved"}>Approved</option>
                    <option value={"open"}>Disburse</option>
                  </CFormSelect>
                </div>
              </CCol>
              <CCol xs={6}>
                <CButton onClick={handleSearch} style={{ marginTop: "24px" }}>
                  Search
                </CButton>
              </CCol>
              <CTableRow>
                <CTableDataCell colSpan={8} style={{ textAlign: "right", fontWeight: "bold" }}>
                  Total Approved Amount
                </CTableDataCell>
                <CTableDataCell style={{ fontWeight: "bold" }}>
                  {getTotalApprovalAmount()}
                </CTableDataCell>
                <CTableDataCell colSpan={2} />
              </CTableRow>
            </CRow>
          </div>
          <div className="serch_bar new-common-table-wrapper"></div>

          <div
            className=" new-table-container"
            ref={printState ? componentPDF : null}
            style={{ padding: printState ? "20px" : "0px" }}
          >
            {printState && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  background:
                    "linear-gradient(180deg, #1e2639, #222b40, #4c5a7a, #7c90c2)",
                  padding: "20px",
                }}
              >
                <img
                  src={COMPANY_AddLogo}
                  alt="Logo"
                  width="50px"
                  height="50px"
                />
                <p style={{ color: "#FFF" }}>Emi Details</p>
                <div style={{ textAlign: "start" }}>
                  <p
                    style={{
                      fontWeight: "bold",
                      color: "#FFF",
                      fontSize: "20px",
                    }}
                  >
                    {COMPANY_NAME}
                  </p>
                  <p style={{ color: "#FFF" }}>{`(${COMPANY_Address})`}</p>
                </div>
              </div>
            )}
            <div style={{ marginTop: "40px" }}>
              <CTable hover className="custom-tablee" responsive>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Sr No.</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Date</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Loan Account Number</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Customer Name</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Father Name</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Grand Father Name</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Phone Number</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Branch Name</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Approved Amount</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">File Charge Include</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Loan Status</span>
                    </CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {newData?.length > 0 &&
                    newData?.map((company, index) => {
                      return (
                        <CTableRow key={index}>
                          <CTableDataCell>{index + 1}</CTableDataCell>
                          <CTableDataCell style={{ cursor: "pointer" }}>
                            {company?.loans[0]?.createdAt?.split("T")[0]
                              ? formatDate(
                                company?.loans[0]?.createdAt?.split("T")[0]
                              )
                              : "-"}
                          </CTableDataCell>
                          <CTableDataCell style={{ cursor: "pointer" }}>
                            {company?.loanAccountNumber
                              ? company?.loanAccountNumber
                              : "-"}
                          </CTableDataCell>
                          <CTableDataCell style={{ cursor: "pointer" }}>
                            {company?.firstName ? company?.firstName : "-"}
                          </CTableDataCell>
                          <CTableDataCell style={{ cursor: "pointer" }}>
                            {company?.fatherName ? company?.fatherName : "-"}
                          </CTableDataCell>
                          <CTableDataCell style={{ cursor: "pointer" }}>
                            {company?.grandFatherName
                              ? company?.grandFatherName
                              : "-"}
                          </CTableDataCell>
                          <CTableDataCell className="">
                            {company?.phoneNumber}
                          </CTableDataCell>
                          <CTableDataCell className="">
                            <span className="">
                              {company?.branch?.branchName}
                            </span>
                          </CTableDataCell>
                          <CTableDataCell style={{ cursor: "pointer" }}>
                            {company?.loans[0]?.approvalAmount
                              ? company?.loans[0]?.approvalAmount
                              : "-"}
                          </CTableDataCell>
                          <CTableDataCell>
                            <input
                              type="checkbox"
                              checked={
                                checkedState[index] ??
                                company?.loans[0]?.approvalfilecharge
                              }
                              onChange={() =>
                                handleCheckboxChange(
                                  index,
                                  company?.loans[0]?.id
                                )
                              }
                            />
                          </CTableDataCell>
                          <CTableDataCell>
                            {company?.loans?.length === 1 ? (
                              company?.loans.map((ele, i) => ele?.status)
                            ) : (
                              <>
                                <CButton style={{ padding: "2px" }}>
                                  Multiple..
                                </CButton>
                              </>
                            )}
                          </CTableDataCell>
                        </CTableRow>
                      );
                    })}
                </CTableBody>
              </CTable>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </div>
  );
};

export default LoanStatus;
